import Composto from './Composto'

export default class CandidatoIdioma {

  constructor() {
    this.id = 0;
    this.candidato_id = new Composto();
    this.tp_idioma = new Composto();
    this.tp_nivel = new Composto();
    this.detalhes = '';
  }

}
